const namespace = "playAnotherGame";

export const MESSAGE_WITH_PRIZE = `${namespace}.messageWithPrize`;
export const MESSAGE_WITHOUT_PRIZE = `${namespace}.messageWithoutPrize`;
export const PRIZE = `${namespace}.prize`;
export const CONFIRM = `${namespace}.confirm`;
export const DECLINE = `${namespace}.decline`;
